export function isCommunity() {
    return window.location.pathname.includes('/communit');
}
